import { get } from "lodash";
import { THEMES_PALETTE } from "utils/constants";

export const isGenerateLinkOpen = (open) =>
  Boolean(open?.projectId && open?.subscriptionId);

/**
 * Same gate as the project drawer: only an internal broker on a theme
 * that owns a prospect process can generate the link.
 */
export const isProspectLinkDisabled = ({ user, processTemplate }) =>
  !get(user, "organization.broker.isInternal") ||
  !get(THEMES_PALETTE, [processTemplate, "PROSPECT_PROCESS"]);

export const getGenerateLinkFlowKey = (open, tracerId) => {
  if (!isGenerateLinkOpen(open)) {
    return "";
  }
  return [
    open.projectId,
    open.subscriptionId,
    tracerId || "",
    open.baseUrl || "",
    open.combinationId || "",
    open.complementaryInsurancePlanId || "",
    open.isSigned ? "1" : "0",
    open.isInfoCompleted ? "1" : "0",
  ].join("|");
};
